<template lang="html">
  <div class="travelers-info">
    <div class="travelers-info-title pf-medium">出游人信息</div>
    <div
      class="traveler"
      v-for="(traveler, index) in travelersShowable"
      :key="'traveler_' + index"
    >
      <p class="traveler-num pf-medium" v-if="expandSwitchNeedShow">
        第{{ index + 1 }}位出游人
      </p>
      <div class="traveler-field">
        <div class="field-name">姓名</div>
        <div class="field-value pf-simbold">{{ traveler.name }}</div>
      </div>
      <div class="devider"></div>
      <div class="traveler-field">
        <div class="field-name">电话</div>
        <div class="field-value pf-simbold">{{ traveler.mobile }}</div>
      </div>
      <div class="devider"></div>
      <div class="traveler-field">
        <div class="field-name">身份证</div>
        <div class="field-value pf-simbold">{{ traveler.card }}</div>
      </div>
      <div class="devider"></div>
    </div>
    <div class="traveler">
      <!--叠起来时，露出一点-->
      <p
        class="traveler-num pf-medium"
        v-if="expandSwitchNeedShow && !expandFlag"
      >
        第2位出游人
      </p>
    </div>
    <div class="expand" @click="expandToggle()" v-if="expandSwitchNeedShow">
      {{ expandFlag ? '收起' : '展开全部' }}
      <img
        class="arrow"
        :class="{ 'arrow-rotate': !expandFlag }"
        src="../../assets/images/order/icon-arrow@3x.png"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    travelers: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      expandFlag: false,
      travelersShowable: []
    }
  },
  created() {
    // 初始化
    this.travelersShowable = this.expandSwitchNeedShow
      ? [this.travelers[0]]
      : this.travelers
  },
  methods: {
    expandToggle() {
      this.expandFlag = !this.expandFlag
      this.travelersShowable = this.expandFlag
        ? this.travelers
        : [this.travelers[0]]
    }
  },
  computed: {
    expandSwitchNeedShow() {
      return this.travelers && this.travelers.length > 1
    }
  },
  components: {}
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.travelers-info {
  margin: rem(20px) rem(24px) rem(20px);
  padding: rem(30px) rem(24px) rem(18px) rem(24px);
  border-radius: rem(16px);
  background: #fff;

  .travelers-info-title {
    font-size: rem(30px);
    padding: 0 0 rem(30px) 0;
  }

  .traveler {
    font-size: rem(24px);
    color: #262626;

    .traveler-num {
      padding: rem(22px) 0 rem(22px) 0;
    }

    .traveler-field {
      display: flex;
      justify-content: space-between;
      padding: rem(22px) 0 rem(22px) 0;
    }
  }

  .expand {
    text-align: center;
    height: rem(76px);
    line-height: rem(76px);
    font-size: rem(26px);
    color: #262626;

    .arrow {
      margin-left: rem(10px);
      width: rem(20px);
      height: rem(20px);
    }
    .arrow-rotate {
      transform: rotate(180deg);
    }
  }

  .devider {
    background: #ededed;
    height: rem(1px);
  }
}
</style>
